import { defineAsyncComponent } from 'vue';

const TextField = defineAsyncComponent(() => import('@maison/components/form/fields/TextField.vue'));
const RadioListField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioListField.vue'));
const SelectField = defineAsyncComponent(() => import('@maison/components/form/fields/SelectField.vue'));
const CheckboxField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxField.vue'));
const PhoneField = defineAsyncComponent(() => import('@maison/components/form/fields/PhoneField.vue'));
const TextareaField = defineAsyncComponent(() => import('@maison/components/form/fields/TextareaField.vue'));
const PasswordField = defineAsyncComponent(() => import('@maison/components/form/fields/PasswordField.vue'));

export function getFieldComponentForType(type) {
  switch (type) {
    case 'select':
      return SelectField;
    case 'radio':
      return RadioListField;
    case 'checkbox':
      return CheckboxField;
    case 'phone':
      return PhoneField;
    case 'textarea':
      return TextareaField;
    case 'password':
      return PasswordField;
    case 'text':
    case 'hidden':
    case 'email':
    default:
      return TextField;
  }
}
